package fr.frux.shared.di

import fr.frux.core.common.di.AppScope
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers
import dev.zacsweers.metro.Qualifier

/**
 * Qualifier for IO Dispatcher.
 */
@Qualifier
@Retention(AnnotationRetention.RUNTIME)
annotation class IoDispatcher

/**
 * Qualifier for Main Dispatcher.
 */
@Qualifier
@Retention(AnnotationRetention.RUNTIME)
annotation class MainDispatcher

/**
 * Qualifier for Default Dispatcher.
 */
@Qualifier
@Retention(AnnotationRetention.RUNTIME)
annotation class DefaultDispatcher

/**
 * Metro DI module providing coroutine dispatchers.
 */
@ContributesTo(AppScope::class)
interface DispatcherModule {

    companion object {
        @Provides
        @SingleIn(AppScope::class)
        @IoDispatcher
        fun provideIoDispatcher(): CoroutineDispatcher = Dispatchers.Default

        @Provides
        @SingleIn(AppScope::class)
        @MainDispatcher
        fun provideMainDispatcher(): CoroutineDispatcher = Dispatchers.Main

        @Provides
        @SingleIn(AppScope::class)
        @DefaultDispatcher
        fun provideDefaultDispatcher(): CoroutineDispatcher = Dispatchers.Default
    }
}
